
import { Component, Input, OnInit } from '@angular/core';

import { IWebexSiteSettings } from 'rev-shared/media/IWebexSiteSettings';
import { orderBy } from 'rev-shared/util/SortUtil';

import { BaseImportDialogComponent } from './BaseImportDialog.Component';
import { IWebexRecording } from './Import.Types';

@Component({
	selector: 'import-webex-dialog',
	templateUrl: './ImportWebexDialog.Component.html'
})
export class ImportWebexDialogComponent extends BaseImportDialogComponent implements OnInit {
	@Input() public webexSitesSettings: IWebexSiteSettings[];
	@Input() public teamId: string;

	public showWebexSiteSelection: boolean = false;
	public selectedSite: IWebexSiteSettings = null;

	public errorGeneric: boolean = false;
	public errorWebExLogin: boolean = false;
	public errorWebExSso: boolean = false;
	public noWebexRecordingsFound: boolean = false;
	public webexRecordings: IWebexRecording[];

	public ngOnInit(): void {
		this.assignColumnDefs();
		if (this.webexSitesSettings?.length > 1) {
			this.showWebexSiteSelection = true;
		} else if (this.webexSitesSettings?.length === 1) {
			this.selectedSite = this.webexSitesSettings[0];
			this.loadRecordings();
		} else {
			this.errorGeneric = true;
		}
	}

	public onNextClick(): void {
		this.showWebexSiteSelection = false;
		this.loadRecordings();
	}

	public onBackToWebexSitesList(): void {
		this.showWebexSiteSelection = true;
		this.selectedSite = null;
		this.clearErrors();
		this.webexRecordings = [];
	}

	public import(): void {
		this.isLoading = true;

		this.getSelectedImports().forEach(selectedImport =>
			this.ImportExternalMediaService.importWebexRecording(
				this.selectedSite.id,
				selectedImport.id,
				selectedImport.topic,
				selectedImport.downloadUrl,
				this.teamId,
				selectedImport.transcriptionFileUrl
			)
		);

		this.closeDialog();
	}

	public fetchRecordings(): Promise<IWebexRecording[]> {
		return this.ImportExternalMediaService.getWebexRecordings(this.selectedSite.id, this.teamId);
	}

	public processRecordings(recordings: IWebexRecording[]): void {
		this.webexRecordings = recordings ? orderBy(recordings, item => item.createTime, false) : [];
	}

	public handleError(error: any): void {
		if (error.status === 401) {
			this.errorWebExLogin = true;
		} else if (error.data.code === 'NoWebexRecordingsFound') {
			this.noWebexRecordingsFound = true;
		} else if (error.data.code === 'InvalidWebexUser') {
			// SSO Login fails
			this.errorWebExSso = true;
		} else {
			this.errorGeneric = true;
		}
	}

	public clearErrors(): void {
		this.errorGeneric = false;
		this.errorWebExLogin = false;
		this.errorWebExSso = false;
		this.noWebexRecordingsFound = false;
	}

	public assignColumnDefs(): void {
		this.columnDefs = [
			...this.getCommonColumnDefs('topic', 'createTime', 'sizeBytes'),
			{
				field: 'transcriptionFileUrl',
				headerName: this.TranslateService.instant('Media_Integrations_WebexMeetings_Transcript_Available'),
				sortable: true,
				tooltipValueGetter: data => data.value ? this.TranslateService.instant('Yes') : this.TranslateService.instant('No'),
				valueFormatter: data => data.value ? this.TranslateService.instant('Yes') : this.TranslateService.instant('No'),
				minWidth: 150,
				maxWidth: 200
			}
		];
	}
}
